import React from 'react';


if (process.env.NODE_ENV === 'development') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
    trackExtraHooks: [
      [React, 'useEffect'],
    ],
  });
}

export const debugRender = (component) => {
  if (process.env.NODE_ENV === 'development') {
    component.whyDidYouRender = true;
  }
};
